import React, { useState } from "react";
import { useNavigate, useLocation } from 'react-router-dom';
import HeaderStyle from '../../Styles/Header.module.css';
import { IoMdClose } from "react-icons/io";
import { getResetPasswordAPI } from "../../../services/routes.services";
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { toast } from 'react-toastify';
import LoginPopup from "./UserLogin";
const ResetPassword = ({ onClose }) => {
  const locationUrl = useLocation();
  const searchParams = new URLSearchParams(locationUrl.search);
  const [resetToken] = useState(searchParams.get('token'));
  const [loginScreen, setLoginScreen] = useState(false)
    console.log(resetToken)
  const [formDataLogin, setFormDataLogin] = useState({
    newPassword: '',
    confirmPassword: '',
  });
  const [errors, setErrors] = useState('');
  const navigate = useNavigate();
  const [tokenError, setTokenError] = useState('')
  const handleChangeLogin = (e) => {
    setFormDataLogin({ ...formDataLogin, [e.target.name]: e.target.value });
    setErrors({ ...errors, [e.target.name]: '' });
  };

  const passwordValidate = () => {
    const newErrors = {};
    if (!formDataLogin.newPassword) newErrors.newPassword = 'New Password is required';
    if (!formDataLogin.confirmPassword) newErrors.confirmPassword = 'Confirm Password is required';
    if (formDataLogin.newPassword !== formDataLogin.confirmPassword)
      newErrors.confirmPassword = 'Passwords do not match';
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const resetPasswordHandler = async () => {
    if (!passwordValidate()) return;
  
  
    try {
      const response = await getResetPasswordAPI(
        { password: formDataLogin.newPassword },
        resetToken
      );
  
      if (response.status === 200) {
        toast.success(response.data.message);
        setLoginScreen(true);
       
      }
    } catch (error) {
      // Try to extract message from API response
      const errorMsg = error.response?.data?.message;
      setTokenError(errorMsg);
      console.error('Reset Password Error:', errorMsg);
    }
  };
  
  

  return (
    <>
    {!loginScreen ? (
        <div className={HeaderStyle.loginWindow}>
            <div className={HeaderStyle.loginContainer}>
                <button onClick={onClose} type="button" className={HeaderStyle.closeLogin}>
                <IoMdClose />
                </button>
                <h3>Reset Password</h3>
                <div>
                <div className={HeaderStyle.inputBox}>
                    <input
                    type="password"
                    name="newPassword"
                    placeholder="Enter New Password"
                    value={formDataLogin.newPassword}
                    onChange={handleChangeLogin}
                    />
                    {errors.newPassword && <p style={{ color: 'red' }}>{errors.newPassword}</p>}
                </div>
                <div className={HeaderStyle.inputBox}>
                    <input
                    type="password"
                    name="confirmPassword"
                    placeholder="Confirm New Password"
                    value={formDataLogin.confirmPassword}
                    onChange={handleChangeLogin}
                    />
                    {errors.confirmPassword && <p style={{ color: 'red' }}>{errors.confirmPassword}</p>}
                </div>
                {tokenError && <p style={{ color: 'red' }}>{tokenError}</p>}
                <div className={HeaderStyle.submitBtn}>
                    <button type="button" onClick={resetPasswordHandler}>Reset Password</button>
                </div>
                </div>
            </div>
        </div>
    ):(
        <LoginPopup />
    )}
          <ToastContainer
  position="top-right"
  autoClose={3000}
  hideProgressBar={false}
  newestOnTop={false}
  closeOnClick
  pauseOnFocusLoss
  draggable
  pauseOnHover
/>
    </>
  );
};

export default ResetPassword;

